import moment from 'moment';
import qs from 'qs';

import createPagination from '../shared/new-pagination';
import http from '../shared/http';

function createList({ namespace, calendar, table, filters, url, perPage, getRequestQuery }) {
	if (!getRequestQuery) {
		getRequestQuery = getDefaultRequestQuery;
	}

	const pagination = createPagination({
		namespace,
		initialState: { perPage }
	});

	// action types
	const FETCH_DATA_SUCCESS = `${namespace}/fetch-data-success`;
	const FETCH_MORE_SUCCESS = `${namespace}/fetch-more-success`;
	const FETCH_DATA_ERROR = `${namespace}/fetch-data-error`;

	// initial state
	const initialState = {
		isLoading: true,
		isError: false,
		data: null,
		pagination: pagination.initialState
	};

	// actions
	const actions = {
		own: {
			fetchData: (props) => (dispatch, getState) => {
				/* resets sorting to default */
				const state = getState()[namespace];

				if (state.table.sortedBy.column.index === 'leads') {
					return dispatch(table.actions.sort(
						state.table.table[0].find(({ header }) => !!header.sorting)
					));
				}
				/* resets sorting to default */

				const externalQuery = (props && props.location && props.location.query && qs.parse(props.location.query)) || {};

				if (externalQuery.entity) {
					const filtersList = externalQuery.entity.filters || [];
					dispatch(filters.actions.setFiltersFromExternalQuery(filtersList));
				}
				if (externalQuery.range) {
					const range = {
						startDate: moment(externalQuery.range[0]).startOf('day'),
						endDate: moment(externalQuery.range[1]).endOf('day')
					};

					dispatch(calendar.actions.calendarChange(range, calendar.actions.calendarApply));
					dispatch(calendar.actions.calendarChange(range, calendar.actions.calendarApply));
				}

				const page = 1;
				request(getRequestQuery(page, getState), FETCH_DATA_SUCCESS)(dispatch)
					.then((action) => {
						if (action.type === FETCH_DATA_SUCCESS) {
							dispatch(pagination.actions.update({
								page,
								total: action.payload.data.total
							}));
						}
					});
			},
			fetchMore: () => (dispatch, getState) => {
				/* resets sorting to default */
				const state = getState()[namespace];

				if (state.table.sortedBy.column.index === 'leads') {
					return dispatch(actions.own.fetchData());
				}
				/* resets sorting to default */

				const page = getState()[namespace].pagination.currentPage + 1;
				request(getRequestQuery(page, getState), FETCH_MORE_SUCCESS)(dispatch)
					.then((action) => {
						if (action.type === FETCH_MORE_SUCCESS) {
							dispatch(pagination.actions.update({
								page,
								total: action.payload.data.total
							}));
						}
					});
			}
		},
		pagination: {
			showMore: () => (dispatch, getState) => {
				dispatch(actions.own.fetchMore());
			}
		}
	};

	const reducers = Object.assign(
		{
			[FETCH_DATA_SUCCESS]: (state, action) => ({
				...state,
				data: action.payload.data.rows,
				isLoading: false,
				isError: false
			}),
			[FETCH_MORE_SUCCESS]: (state, action) => ({
				...state,
				data: state.data.concat(action.payload.data.rows),
				isLoading: false,
				isError: false
			}),
			[FETCH_DATA_ERROR]: (state, action) => ({
				...state,
				isLoading: false,
				isError: true
			})
		},
		pagination.reducers
	);

	// selectors
	const selectors = {
		select: (state, field) => state[namespace][field],
		getPagination: pagination.selectors.getPagination
	};

	function getDefaultRequestQuery(page, getState) {
		const state = getState()[namespace];

		const limit = state.pagination.perPage;

		return {
			offset: (page - 1) * limit,
			limit
		};
	}

	function request(query, successActionType) {
		return http({
			url,
			method: 'get',
			actions: [successActionType, FETCH_DATA_ERROR],
			query
		});
	}

	return { actions, selectors, reducers, initialState };
}

export default createList;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/alerts-analytics/create-list.js